/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Empty_DescriptionInputs */

const es_components_file_tree_empty_description = /** @type {(inputs: Components_File_Tree_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron archivos o carpetas aquí.`)
};

const en_components_file_tree_empty_description = /** @type {(inputs: Components_File_Tree_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files or folders found here.`)
};

/**
* | output |
* | --- |
* | "No files or folders found here." |
*
* @param {Components_File_Tree_Empty_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_empty_description = /** @type {((inputs?: Components_File_Tree_Empty_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Empty_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_empty_description(inputs)
	return en_components_file_tree_empty_description(inputs)
});
export { components_file_tree_empty_description as "components.file_tree.empty_description" }